// extracted by mini-css-extract-plugin
module.exports = {"formWrapper":"CommonAdminPanel_formWrapper__tzvZ5","wideForm":"CommonAdminPanel_wideForm__s3Nz4"};